<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		FlexibleCard,
		LinearGauge,
		SystemStyles,
		IconButton,
		AdvancedCard,
	} from '@Shelly/shelly-design-system';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	import { findDeviceByIP } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_helpers';
	//Components
	import EvChargerAutoBalanceModal from './Settings/EvChargerAutoBalanceModal.svelte';
	import EvChargerAutoBalanceError from './Settings/EvChargerAutoBalanceError.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device, statuses: VCInterfaceStatus[];

	let showConfigWizard = false;

	$: autoBalance = getTemplateService(device).settings?.auto_balance;
</script>

<FlexibleCard
	backgroundColor={$showNewLayout ? '--color-0' : undefined}
	class="mb-s"
	padding="m"
	mainContentPrioritySlot="both"
	header={autoBalance?.enable === true
		? $format('mode_auto_balance', {
				default: 'Auto balance',
			})
		: $format('label_manual_limit', {
				default: 'Manual limit',
			})}
	icon="fas fa-transformer-bolt"
>
	<EvChargerAutoBalanceError {device} />
	{#if autoBalance?.enable === true}
		<hr class="mt-s mb-s" />
		<AdvancedCard
			{...findDeviceByIP(autoBalance.em_ip)}
			isCondensed
			class="width-md-l width-sm-full mb-s"
		></AdvancedCard>
		<hr class="mb-m" />
		<LinearGauge
			class="mt-s"
			type="incremented"
			incrementedValue={{
				value: autoBalance.max_current,
				color: SystemStyles.COLOR_ELECTRIC_VEHICLE,
				labelProps: {
					icon: 'fas fa-car',
					value: `${autoBalance.max_current}A`,
					iconColor: SystemStyles.COLOR_ELECTRIC_VEHICLE,
				},
			}}
			unit="A"
			minValue={8}
			maxValue={40}
		/>
	{:else if autoBalance?.enable === false}
		{@const currentLimit = statuses.find((i) => i.name == 'current_limit')}
		<LinearGauge
			class="mt-s"
			type="incremented"
			incrementedValue={{
				value: currentLimit?.rawValue ?? 0,
				color: SystemStyles.COLOR_ELECTRIC_VEHICLE,
				labelProps: {
					icon: 'fas fa-car',
					value: currentLimit?.value || '',
					iconColor: SystemStyles.COLOR_ELECTRIC_VEHICLE,
				},
			}}
			unit={currentLimit?.config?.unit || 'A'}
			minValue={currentLimit?.config?.min ?? 0}
			maxValue={currentLimit?.config?.max ?? 0}
		/>
	{/if}
	<div slot="headerRigthContent">
		<IconButton
			aria-label={$format('button_open_configuration_wizard', {
				default: 'Open configuration wizard',
			})}
			variant="secondary"
			icon="fas fa-gear"
			on:click={() => (showConfigWizard = true)}
		/>
	</div>
</FlexibleCard>
{#if showConfigWizard}
	<EvChargerAutoBalanceModal {device} {statuses} bind:showModal={showConfigWizard} />
{/if}
